export default "__VITE_ASSET__BwkhsJk___"